var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("DateTimePicker", {
        attrs: {
          "min-date": new Date(),
          mode: "dateTime",
          is24hr: "",
          popover: {
            placement: "top",
            positionFixed: true
          },
          "valid-hours": _vm.validHours,
          "minute-increment": 15
        },
        on: { popoverDidHide: _vm.dateSelected },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var inputValue = ref.inputValue
              var togglePopover = ref.togglePopover
              var hidePopover = ref.hidePopover
              return [
                _c("div", { staticClass: "dates-list mt-2 mb-3" }, [
                  _vm.potentialDates.length > 0
                    ? _c(
                        "span",
                        { staticClass: "dates-list--chosen" },
                        _vm._l(_vm.potentialDates, function(potentialDate) {
                          return _c(
                            "span",
                            {
                              key: potentialDate.id,
                              class: {
                                "has-errors": !_vm.isValid(potentialDate)
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("dateByObject")(potentialDate.date)
                                    ) +
                                    ", " +
                                    _vm._s(
                                      _vm._f("timeByObject")(potentialDate.time)
                                    ) +
                                    " Uhr\n\t\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.editDate(
                                        $event,
                                        potentialDate,
                                        togglePopover
                                      )
                                    }
                                  }
                                },
                                [_c("Icon", { attrs: { icon: "edit" } })],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.removeDate(potentialDate)
                                    }
                                  }
                                },
                                [_c("Icon", { attrs: { icon: "close" } })],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "dates-list--button" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            return togglePopover({ ref: $event.target })
                          }
                        }
                      },
                      [
                        _c("Icon", { attrs: { icon: "plus-circle" } }),
                        _vm._v(
                          "\n\t\t\t\t\t\tTerminvorschlag hinzufügen\n\t\t\t\t\t"
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.error
                  ? _c(
                      "div",
                      {
                        class: [
                          "my-1",
                          "error",
                          { "font-size-big": _vm.error.big }
                        ]
                      },
                      [_vm._v(_vm._s(_vm.error.message))]
                    )
                  : _vm._e()
              ]
            }
          }
        ]),
        model: {
          value: _vm.selection,
          callback: function($$v) {
            _vm.selection = $$v
          },
          expression: "selection"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }